import {LongTask, UiLongTask} from 'types/long-task';

export const isLongTask = (longTask: unknown): longTask is LongTask => {
    if (typeof longTask !== 'object' || longTask === null) {
        return false;
    } else if (!('completion' in longTask)) {
        return false;
    } else if (!('uilongtask' in longTask)) {
        return false;
    } else {
        return true;
    }
};

export const isUiLongTask = (uiLongTask: unknown): uiLongTask is UiLongTask => {
    if (typeof uiLongTask !== 'object' || uiLongTask === null) {
        return false;
    } else if (!('currentProgress' in uiLongTask)) {
        return false;
    } else if (!('errors' in uiLongTask)) {
        return false;
    } else if (!('finished' in uiLongTask)) {
        return false;
    } else {
        return true;
    }
};
